import { client } from "@/config/client"

export function deleteSubtheme(subthemeId: string) {
  return client.del(`/v1/learning-paths/subthemes/${subthemeId}`)
}
